<template>
  <div>
    <h1>wizard {{currentStep}}</h1>
    <button type="button" v-if="!isFirstStep" @click="goToPrevStep()">Prev</button>
    <button type="button" v-if="!isLastStep" @click="goToNextStep()">Next</button>

    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  created() {
    this.initWizard()
  },
  methods: {
    ...mapActions('wizard', ['goToNextStep', 'goToPrevStep', 'initWizard'])
  },
  computed: {
    ...mapGetters('wizard', ['currentStep', 'isFirstStep', 'isLastStep'])
  }
}
</script>

